export default __webpack_public_path__ + "static/media/image-not-found.da4174d9.svg";